import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/common.service';
import { Profile, PaymentMethod, PaymentInfo, PaymentIntent as ProfilePaymentIntent } from 'profile-api';
import { ConfigurationVariablesList } from 'std-api';
import { GetCreditCardName } from '../utils/credit-card-name-getter';
import { Tender } from 'tender-api';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StripeService } from 'ngx-stripe';
import { PaymentIntent } from '@stripe/stripe-js';

@Component({
    selector: 'app-buy-new-cluster-tender',
    templateUrl: './buy-new-cluster-tender.component.html',
    styleUrls: ['./buy-new-cluster-tender.component.css']
})
export class BuyNewClusterTenderComponent implements OnInit {

    constructor(
        private commonService: CommonService,
        private router: Router,
        private stripeService: StripeService
    ) { }

    profile: Profile;
    tenderPurchasePrice: Number;
    paymentMethod: PaymentMethod;
    creditCardName: string;
    creditCardLoading: boolean = false;
    prepaidCreditLoading: boolean = false;
    usePrepaidCreditsDisabled: string = "";
    prepaidCreditNumber: Number = 0;
    error: string = "no_error";

    privacyForm = new FormGroup({
        conditions: new FormControl('', [Validators.required]),
        privacy: new FormControl('', [Validators.required])
    });

    ngOnInit(): void {
        window['moment'] = moment;
        localStorage.removeItem('ERROR_MSG');
        localStorage.removeItem('ERROR_MSG_DET');
        this.commonService.getProfile().then((profile: Profile) => {
            this.profile = profile;
            if (this.profile.clusterPrepaidCredits && this.profile.clusterPrepaidCredits.remaining && this.profile.clusterPrepaidCredits.remaining > 0 &&
                moment(this.profile.clusterPrepaidCredits.expirationDate) >= moment()) {
                this.usePrepaidCreditsDisabled = "";
                this.prepaidCreditNumber = profile.clusterPrepaidCredits.remaining;
            } else {
                this.usePrepaidCreditsDisabled = "-disabled";
            }
        });

        this.getTenderPurchasePrice();

        this.getPaymentMethod();
    }

    getTenderPurchasePrice() {
        this.commonService.getConfigurationVariables().then(
            (variables: ConfigurationVariablesList) => {
                console.log('TENDER_PURCHASE_PRICE: ' + variables['TENDER_PURCHASE_PRICE']);
                this.tenderPurchasePrice = variables['TENDER_PURCHASE_PRICE'];
            }
        );
    }

    getPaymentMethod() {
        this.creditCardLoading = true;
        this.commonService.getPaymentMethodService().profilePaymentMethodGet().subscribe(
            (paymentMethod: PaymentMethod) => {
                this.paymentMethod = paymentMethod;
                this.creditCardName = GetCreditCardName(paymentMethod.creditCardBrand);
                this.creditCardLoading = false;
            },
            (error) => {
                this.creditCardLoading = false;
                this.error = "Si è verificato un errore durante il caricamento della carta di credito.";
                console.log(error);
            }
        )
    }

    usePrepaidCredits() {
        /*
        You cannot use prepaid credits if:
        - profile.clusterPrepaidCredits = null
        - profile.clusterPrepaidCredits.remaining = null || profile.clusterPrepaidCredits.remaining = 0
        - profile.clusterPrepaidCredits.expirationDate < current_date
        */

        if (this.profile.clusterPrepaidCredits && this.profile.clusterPrepaidCredits.remaining && this.profile.clusterPrepaidCredits.remaining > 0 &&
            moment(this.profile.clusterPrepaidCredits.expirationDate) >= moment()) {
            this.postTender(Tender.PaymentMethodEnum.Prepaid, null, null, null, null).then(
                (tender: Tender) => {
                    this.goToThanksPage();
                }
            ).catch(
                (error) => {
                    console.log(error);
                    localStorage.setItem('ERROR_MSG', error);
                    this.goToThanksPage();
                }
            );
        }
    }

    buyWithCreditCard() {
        this.resetError();

        if (!this.privacyForm.valid || this.privacyForm.get('privacy').value === false || this.privacyForm.get('conditions').value === false) {
            this.error = "Per poter procedere è necessario prendere visione delle condizioni generali e della privacy.";
            console.log("Invalid privacy form");
            return;
        }

        this.creditCardLoading = true;
        const transactionInfo = { amount: this.tenderPurchasePrice } as PaymentInfo;
        this.commonService.getPaymentMethodService().profileStripePaymentIntentPost(transactionInfo).subscribe(
            (paymentIntent: ProfilePaymentIntent) => {
                //Payment succesfully directly on server. Save the tender
                this.postTender(Tender.PaymentMethodEnum.CreditCard,
                    this.paymentMethod.creditCardToken,
                    null,
                    paymentIntent.paymentIntentId,
                    paymentIntent.transactionTime).then(
                        () => {
                            this.creditCardLoading = false;
                            this.goToThanksPage();
                        }
                    ).catch(
                        (error) => {
                            this.creditCardLoading = false;
                            console.log(error);
                            localStorage.setItem('ERROR_MSG', this.getSaveErrorMessage() + error);
                            this.goToThanksPage();
                        }
                    );
            },
            (error) => {
                if (error.error.cardExceptionErrorCode === 'authentication_required') {
                    this.confirmCardPayment(error.error.clientSecret, error.error.paymentMethodId);
                } else {
                    this.creditCardLoading = false;
                    console.log(error);
                    localStorage.setItem('ERROR_MSG', this.getCardErrorMessage(error.error.cardExceptionError));
                    localStorage.setItem('ERROR_MSG_DET', this.getCardErrorMessageDetail());
                    this.goToThanksPage();
                }
            }
        );
    }

    getSaveErrorMessage() {
        return "Qualcosa non ha funzionato nella creazione della gara. Riprova più tardi. ";
    }

    getCardErrorMessage(cardExceptionError: string) {
        return "Si è verificato un errore nel pagamento con la carta xxxx-xxxx-xxxx-" +
            this.paymentMethod.creditCardLast4 + ": " + cardExceptionError;
    }

    getCardErrorMessageDetail() {
        return "La gara è stata comunque salvata e la puoi trovare nella tua area riservata.";
    }

    goToThanksPage() {
        this.router.navigate(['/grazieacquisto']);
    }

    postTender(tenderPaymentMethod: Tender.PaymentMethodEnum,
        paymentMethodId: string,
        transactionError: string,
        paymentIntentId: string,
        transactionTime: number) {

        let tender = JSON.parse(localStorage.getItem('TEMP_TENDER'));

        console.log(tender);

        if (tender) {
            tender.paymentMethod = tenderPaymentMethod;
            tender.stripePaymentMethodId = paymentMethodId;
            tender.transactionError = transactionError;
            tender.paymentIntentId = paymentIntentId;
            tender.transactionTime = transactionTime;
            tender.tenderType = 'CLUSTER';
            tender.requestDataEntryType = 'METRIC_CALCULATION';

            return new Promise(
                (resolve, reject) => {
                    this.commonService.getTenderService().tenderPost(tender).subscribe(
                        (tender: Tender) => {
                            resolve(tender);
                        },
                        (error) => {
                            console.log("Error unable to post tender: " + error);
                            reject(error)
                        }
                    )
                }
            );
        } else {
            return new Promise((error) => { error() });
        }

    }

    confirmCardPayment(clientSecret: string, paymentMethodId: string) {
        this.stripeService.confirmCardPayment(clientSecret, {
            payment_method: paymentMethodId
        }).subscribe(
            (value: { paymentIntent: PaymentIntent, error: any }) => {
                if (value.paymentIntent) {
                    //Client authorization sucess. Save the tender
                    this.postTender(Tender.PaymentMethodEnum.CreditCard,
                        this.paymentMethod.creditCardToken,
                        null,
                        value.paymentIntent.id,
                        value.paymentIntent.created).then(
                            () => {
                                this.creditCardLoading = false;
                                this.goToThanksPage();
                            }
                        ).catch(
                            (error) => {
                                this.creditCardLoading = false;
                                console.log(error);
                                localStorage.setItem('ERROR_MSG', this.getSaveErrorMessage() + error);
                                this.goToThanksPage();
                            }
                        );
                } else {
                    //Payment intent is null when customer close authentication window without proceede to authenticate
                    this.creditCardLoading = false;
                }
            },
            (error) => {
                this.creditCardLoading = false;
                console.log(error);
                localStorage.setItem('ERROR_MSG', this.getCardErrorMessage(error.error.cardExceptionError));
                localStorage.setItem('ERROR_MSG_DET', this.getCardErrorMessageDetail());
                this.goToThanksPage();
            }
        );
    }

    buyPrepaidPacket() {
        this.router.navigate(['/acquistapacchetto'], { queryParams: { "fromTender": 'yes' } });
    }

    resetError() {
        this.error = 'no_error';
    }
}
